module.exports = __webpack_public_path__ + "img/logo.34f9e4c5.svg";